<div class="register-layout">
  <div class="row form-layout">
    <div class="col-md-10 form position-relative">
      <div>
        <div class="row">
          <form class="row g-3" novalidate [ngClass]="loading ? 'blur-background' : ''">
            <div *ngIf="loading " class="position-absolute top-50 start-100 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div>
              <div class="form-label ">
                <h2 class="dashboard-sub-heading">Assign Exchanges</h2>
              </div>

              <hr>

              <p class="form-label"><i class="bi bi-info-circle"></i> Select one or more exchange and
                click button to assign
              </p>
              <div class="row mt-4">
                <div class="col-md-5 text-start">
                  <div class="panel m-height panel-default">
                    <div class="form-label">All Exchanges</div>
                    <div class="mt-2 mb-2">
                      <mdb-form-control>
                        <input #input (input)="searchUnselected(input.value)" mdbInput
                               type="search" id="form1" class="form-control" />
                        <label mdbLabel class="form-label p-1" for="form1">Search</label>
                      </mdb-form-control>
                    </div>
                    <div class="panel-body">
                      <ul id="unselectedList">
                        <li *ngFor="let item of unselectedExchanges"
                            (click)="togglePendingSelection(item)" class="list-group-item"
                            [class.selected]="item.selected">
                          {{item.exchangeCode}}
                      </ul>
                      <div *ngIf="unselectedExchanges==undefined || unselectedExchanges.length == 0"
                           class="mt-3">
                        <h4 class="dashboard-heading m-l-10"
                            style="text-align: center; color: rgb(175, 175, 175); margin: 3px; line-height: inherit;">
                          No exchanges available
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-1 mt-5" style="padding: 0px;">
                  <div class="text-center">
                    <button
                      [disabled]="unselectedExchanges==undefined || unselectedExchanges.length == 0"
                      type="button" class="btn btn-primary mt-1 mb-1 ml-1 mr-1"
                      title="Assign selected exchanges" (click)="addToSelectedExchanges()">
                      <i class="custom-icon-button2"></i>
                    </button>
                    <button
                      [disabled]="selectedExchanges==undefined || selectedExchanges.length == 0"
                      type="button" class="btn btn-warning  mt-1 mb-1 ml-1 mr-1"
                      title="Unassign selected exchanges" (click)="removeFromSelectedExchanges()">
                      <i class="custom-icon-button1"></i>
                    </button>
                    <button
                      [disabled]="unselectedExchanges==undefined || unselectedExchanges.length == 0"
                      type="button" class="btn btn-primary  mt-1 mb-1 ml-1 mr-1"
                      title="Assign all exchanges" (click)="addAllToSelectedExchanges()">
                      <i class="custom-icon-button4"></i>
                    </button>
                    <button
                      [disabled]="selectedExchanges==undefined || selectedExchanges.length == 0"
                      type="button" class="btn btn-warning  mt-1 mb-1 ml-1 mr-1"
                      title="Unassign all exchanges" (click)="addAllToUnselectedExchanges()">
                      <i class="custom-icon-button3"></i>
                    </button>
                  </div>
                </div>

                <div class="col-md-5 text-start">
                  <div class="panel m-heightpanel-default">
                    <div class="form-label">Assigned Exchanges</div>
                    <div class="panel-body panel-body-selected"
                         [class.panel-body-error]="noExchangeAssigned">
                      <li *ngFor="let item of selectedExchanges"
                          (click)="togglePendingSelection( item )" class="list-group-item"
                          [class.selectedA]="item.selected">
                        <i class="fas fa-spinner mr-2" style="color: #ffb626;"></i>
                        {{item.exchangeCode}}
                      <li *ngFor="let item of alreadyassignedExchanges" class="list-group-item"
                          style="background-color: #f5f5f5;">
                        <i class="fas fa-check-circle mr-2" style="color: #54b4a8;"></i>
                        {{item.exchangeCode}}
                      </li>
                      <div *ngIf="(alreadyassignedExchanges==undefined || alreadyassignedExchanges.length == 0) && (selectedExchanges==undefined || selectedExchanges.length == 0)"
                           class="mt-3">
                        <h4 class="dashboard-heading m-l-10"
                            style="text-align: center; color: rgb(175, 175, 175); margin: 3px; line-height: inherit;">
                          No exchange assigned yet
                        </h4>
                      </div>
                    </div>
                    <div *ngIf="noExchangeAssigned">
                      <p class="panel-error-msg">Please assign at least one exchange</p>
                    </div>
                  </div>
                </div>

                <!-- <div class="d-flex" style="justify-content:flex-end;">
                    <div class="">
                        <div class="p-2">
                            <button [disabled]="loading" type="button" class="btn btn-primary mt-4"
                                type="submit" (click)="setInstExchangeList()">
                                <div *ngIf="loading" class="spinner-border spinner-border-sm text-light"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p *ngIf="!loading">
                                    Complete
                                </p>
                            </button>
                        </div>
                    </div>
                </div> -->

              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- <div *ngIf="initialLoading" class="position-absolute top-50 start-50 translate-middle">
          <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
              <span class="visually-hidden">Loading...</span>
          </div>
      </div> -->
    </div>
  </div>
</div>
